import WaveSurfer from 'wavesurfer.js';

// eslint-disable-next-line
export default ({ app }, inject) => {
  inject('WaveSurfer', WaveSurfer);
};
